export default __webpack_public_path__ + "static/media/Group 851.dc6ec685.png";